import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CART_NOTIFICATION } from "../../../../locales/components/namespaces";

const CartNotificationItem = ({ product, isMainProduct, onAddClick }) => {
  const { t } = useTranslation(CART_NOTIFICATION);
  const imageSize = isMainProduct ? 80 : 60;
  const fontSize = isMainProduct ? "14px" : "12px";
  const priceFontSize = isMainProduct ? "16px" : "14px";

  return (
    <Box
      sx={{
        display: "flex",
        gap: 1.5,
        p: 1,
        width: "100%",
        backgroundColor: isMainProduct ? "#F0F0F0" : "transparent",
        borderRadius: isMainProduct ? "8px" : "0px",
        border: isMainProduct ? "1px solid #e0e0e0" : "none",
        alignItems: "flex-start",
      }}
    >
      {/* Product Image */}
      <Box
        sx={{
          width: `80px`,
          height: `70px`,
          minWidth: `${imageSize}px`,
          backgroundColor: "#ffffff",
          borderRadius: "8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          overflow: "hidden",
          border: "1px solid #e0e0e0",
        }}
      >
        {product.image ? (
          <img
            src={product.image}
            alt={product.title}
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              width: "auto",
              height: "auto",
              objectFit: "scale-down",
            }}
          />
        ) : (
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#f5f5f5",
              color: "#999",
              fontSize: "12px",
              fontWeight: 700,
              textAlign: "center",
              p: 1,
            }}
          >
            {t("no_image")}
          </Box>
        )}
      </Box>

      {/* Product Info */}
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 0.5 }}>
        {/* Product Code */}
        {product.code && !isMainProduct && (
          <Box>
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: "14px",
                fontFamily: "Roboto",
                color: "#000000ff",
                lineHeight: "120%",
              }}
            >
              {t("code_label")} {product.code}
            </Typography>
          </Box>
        )}

        {/* Product Name */}
        <Typography
          sx={{
            fontWeight: 400,
            fontSize: fontSize,
            fontFamily: "Roboto",
            color: "#111",
            lineHeight: "120%",
            pt: isMainProduct ? 1 : 0,
          }}
        >
          {isMainProduct && product.quantity ? `${product.quantity}x ` : ""}
          {product.title}
        </Typography>

        {/* Price and Add Button */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: priceFontSize,
              fontFamily: "Roboto",
              color: "#111",
              lineHeight: "120%",
            }}
          >
            {isMainProduct && product.quantity
              ? `${(product.price * product.quantity).toFixed(2)} €`
              : `${product.price} €`}
          </Typography>

          {/* Add Button */}
          {!isMainProduct && (
            <Button
              variant="outlined"
              onClick={onAddClick}
              sx={{
                width: "100px",
                height: "25px",
                borderRadius: "80px",
                fontSize: "12px",
                fontWeight: 900,
                fontFamily: "Zen Maru Gothic",
                whiteSpace: "nowrap",
                border: "1px solid",
                borderColor: "primary.main",
                color: "primary.main",
                "&:hover": {
                  backgroundColor: "rgba(0, 0, 0, 0.04)",
                },
                textTransform: "uppercase",
              }}
            >
              {t("add_button")}
            </Button>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default CartNotificationItem;
